module.exports = __webpack_public_path__ + "assets/images/vcr_hotel-04.2f90d7a2fad93eea3045082f7f2e775e.svg";